
// this email regex pass with 99.99% verification: http://emailregex.com/
const VALID_EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// According to RFC section 2, the email validation above missed some cases
// https://tools.ietf.org/html/rfc3696#section-2%
const INVALID_RFC_EMAIL_REGEX = /@-|@.*\.-|@.*-\./;

export namespace EmailUtil {
    // this email regex pass with 99.99% verification: http://emailregex.com/
    export function validateEmail(email: string): boolean {

        let result = false;
        if (VALID_EMAIL_REGEX.test(email) && !INVALID_RFC_EMAIL_REGEX.test(email)) {
            result = true;
        }
        return result;
    }
}
